export const LINK_PAGE_BASE_URI = 'link-page';
